// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clear-icon {
  color: var(--primary-light);
  position: absolute;
  font-size: 14px;
  right: 2px;
  top: 2px;
  transform: rotate(45deg);
  cursor: pointer;
}

.clear-icon:hover {
  color: var(--primary);
  transition: 0.1s ease-in;
}

.input {
  border-bottom: var(--primary-rgb, 0.5) solid 1px;
  margin-top: 1px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/controls/autocomplete/autocomplete.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,wBAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;AACF;;AAEA;EACE,gDAAA;EACA,eAAA;EACA,kBAAA;AACF","sourcesContent":[".clear-icon {\n  color: var(--primary-light);\n  position: absolute;\n  font-size: 14px;\n  right: 2px;\n  top: 2px;\n  transform: rotate(45deg);\n  cursor: pointer;\n}\n\n.clear-icon:hover {\n  color: var(--primary);\n  transition: .1s ease-in;\n}\n\n.input {\n  border-bottom: var(--primary-rgb, 0.5) solid 1px;\n  margin-top: 1px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
